<div id="report">
  <div class="headercontainer"></div>
  <div id="questionscontainer" [innerHTML]="sanitizedHtml" *ngIf="sanitizedHtml"></div>
  <div *ngIf="!sanitizedHtml" class="empty-message">
    <p>NO DATA</p>
  </div>
</div>
<button id="printPageBtn" [hidden]="!sanitizedHtml">Download</button>



<script>
  // Function to create the header section
  function createHeader(headerHtml) {
      const header = document.querySelector('.headercontainer');
      header.appendChild(headerHtml);

      return header;
  }
</script>